import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable, tap } from "rxjs";
import {
  ActionResult,
  ActionResultList,
  CompetitorFilter, CompetitorResults,
  EventItem,
  FetchEventByIdRequest,
  FetchRaceByIdRequest,
  PagedFilter,
  Race
} from "@model";
import { LoaderService } from "./loader.service";
import { EnvironmentService } from "./environment.service";

@Injectable({ providedIn: 'root' })
export class LiveResultsService {
  constructor(
    private http: HttpClient,
    private loaderService: LoaderService,
    private environmentService: EnvironmentService,
  ) {}

  fetchLiveEvents(): Observable<EventItem[]> {
    return this.http.get<ActionResultList<EventItem[], number>>(`${this.environmentService.getApiUrl()}/api/public/live/events`).pipe(
      map(value => (value?.result) ? value.result : [])
    );
  }

  getFinishedCount(raceId: number | undefined): Observable<number | undefined> {
    return this.http.post<ActionResult<number>>(
        this.environmentService.getApiUrl() + "/api/public/live/finished", raceId
    ).pipe(map(value => value?.result));
  }

  getStartedCount(raceId: number | undefined): Observable<number | undefined> {
    return this.http.post<ActionResult<number>>(
      this.environmentService.getApiUrl() + "/api/public/live/started", raceId
    ).pipe(map(value => value?.result));
  }

  fetchLiveEvent(eventId: FetchEventByIdRequest, hideLoading?: boolean): Observable<EventItem | null> {
    if (!hideLoading) this.loaderService.startLoading();
    return this.http.post<ActionResult<EventItem>>(`${this.environmentService.getApiUrl()}/api/public/live/event`, eventId).pipe(
      tap(() => { if (!hideLoading) this.loaderService.dismissLoading() }),
      map(value => value?.result || null)
    );
  }

  fetchLiveRace(raceRequest: FetchRaceByIdRequest, hideLoading?: boolean): Observable<Race | null> {
    if (!hideLoading) this.loaderService.startLoading();
    return this.http.post<ActionResult<Race>>(`${this.environmentService.getApiUrl()}/api/public/live/race`, raceRequest).pipe(
      tap(() => { if (!hideLoading) this.loaderService.dismissLoading() }),
      map(value => value?.result || null)
    );
  }
}
